import { useEffect, useState, useRef, useCallback } from "react";
import { Video, LogOut, KeyRound } from "lucide-react";
import { useNavigate } from "react-router";
import LeftPanel from "../LeftPanel/LeftPanel";
import RightPanel from "../RightPanel/RightPanel";
import { Gem, Plus, PanelRightOpen, PanelRightClose, History, Pencil, Trash, Check, X, CheckCircle, Loader2, Clock } from "lucide-react";
import apiClient from "../ApiClient/ApiClient";
import cat from "../assets/video/cat.png"
import { io } from "socket.io-client";
import ChangePassword from "../ChangePassword/ChangePassword";

const Dashboard = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const navigate = useNavigate();
    const [rightPanelValue, setRightPanelValue] = useState(null);
    const [hasilGenerate, setHasilGenerate] = useState(null);
    const [hasilCheck, setHasilCheck] = useState(null);

    const [quota, setQuota] = useState(0);
    const [muncul, setMuncul] = useState(false);

    const [instruct, setInstruct] = useState("");
    const [fileTarget, setFileTarget] = useState([]);
    const [duration, setDuration] = useState(0);
    const [inputDuration, setInputDuration] = useState(0);
    const [outputResult, setOutputResult] = useState(3);
    const [textLoading, setTextLoading] = useState("")

    const [totalHistory, setTotalHistory] = useState(null);
    const [arrHistory, setArrHistory] = useState([{
        created_at: null,
        expires_at: "2025-12-23T10:10:08.789Z",
        id: "",
        result_path: null,
        session_name: null,
        settings: null,
        source_path: [null],
        status: null,
        update_at: null,
        user_id: 0,
    }]);

    const [editIndex, setEditIndex] = useState(null);
    const [editOrDele, setEditOrDel] = useState("");
    const [nameSession, setNameSession] = useState("");
    const [idSession, setIdSession] = useState("");
    const [listVideoSession, setListVideoSession] = useState(null);
    const [listVideoNames, setListVideoNames] = useState([]);
    const [listVideoDuration, setListVideoDuration] = useState([]);



    const handleLogout = () => {
        localStorage.clear();
        navigate("/auth");
    };

    function formatAngka(angka) {
        const bulat = Math.round(angka); // atau Math.floor/ceil jika perlu
        return new Intl.NumberFormat('id-ID', {
            maximumFractionDigits: 0 // pastikan tidak ada desimal
        }).format(bulat);
    }

    const AnimatedDots = () => {
        const [dots, setDots] = useState('');

        useEffect(() => {
            const intervals = ['', '.', '..', '...', '....', '.....', '..... 👻', '..... 👻✨'];
            let i = 0;

            const interval = setInterval(() => {
            setDots(intervals[i]);
            i = (i + 1) % intervals.length;
            }, 400); // ubah tiap 300ms

            return () => clearInterval(interval);
        }, []);

        return <span>{dots}</span>;
    };

    const checkCredit = () => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/quota/get`,
        };

        apiClient.request(config)
        .then((response) => {
            if(response.data.current_quota < 10000000) {
                setQuota(formatAngka(response.data.current_quota));
            } else {
                setQuota(formatAngka(999999999));
            }
            setMuncul(true)
            
        })
        .catch((error) => {
            console.log(error);
            navigate("/auth")
        });
    }

    const generateVideo = () => {
        setHasilCheck(null)

        setListVideoSession(null)

        // Use socket manager instead of creating new socket manually
        getOrCreateSocket(idSession);
        console.log("File Target = ", fileTarget)
        if(fileTarget.length >= 1) {
                setFileTarget([])
                checkCredit()
                const fileNamesArray = fileTarget.map((item) => {
                    return item.name || '';
                }) || [];
    
                let data = new FormData();
                data.append('filenames', JSON.stringify(fileNamesArray))
                data.append('video_session', idSession)
                data.append('duration', Math.floor(duration));
                data.append('instructions', instruct);
                if(rightPanelValue){
                    data.append('ref_templates', rightPanelValue);
                } else {
                    data.append('ref_templates', "");
                }
                data.append('crop_mode', "Original");
                data.append('num_variations', outputResult);
                
                // console.log("payload generate video =>", data)
            
                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: `${process.env.REACT_APP_API_URL}/video/generate/gcs`,
                    data : data
                };
            
                apiClient.request(config)
                .then((response) => {
                    setTimeout(() => {
                        console.log(response);
                        checkCredit()
                        // setHasilGenerate(response.data.result);
    
    
                        window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                        });
    
    
                        setIsModalOpen(false)
                        historyGenerate()
                        // socket.disconnect();
                        setTextLoading("")
                    }, 2000)
    
                })
                .catch((error) => {
                    console.log(error);
                    setIsModalOpen(false)
                    // socket.disconnect();
                });
        } else {
            let data = new FormData();
            data.append('video_session', idSession)
            data.append('duration', Math.floor(duration));
            data.append('instructions', instruct);
            if(rightPanelValue){
                data.append('ref_templates', rightPanelValue);
            } else {
                data.append('ref_templates', "");
            }
            data.append('crop_mode', "Original");
            data.append('num_variations', outputResult);
            
            // console.log("payload generate video =>", data)
        
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}/video/generate/gcs`,
                data : data
            };
        
            apiClient.request(config)
            .then((response) => {
                setTimeout(() => {
                    console.log(response);
                    checkCredit()
                    // setHasilGenerate(response.data.result);
                    window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                    });
                    setIsModalOpen(false)
                    historyGenerate()
                    // socket.disconnect();
                    setTextLoading("")
                }, 2000)

            })
            .catch((error) => {
                console.log(error);
                setIsModalOpen(false)
                // socket.disconnect();
            });
        }


        

        
    }

    useEffect(() => {
        const token = localStorage.getItem('token');
        if(token){
            // console.log(token)
            checkCredit();
        }else {
            navigate("/auth")
        }
    }, [])

    const [buka, setBuka] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {

        const checkIfMobile = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);

        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    useEffect(() => {
        // console.log(isMobile)
        if (!isMobile) {
        setBuka(true);
        }else{
        setBuka(false); 
        }
    }, [isMobile]);

    function formatBulanTanggalWaktu(isoString) {
        if(!isoString || isoString == null) return
        const date = new Date(isoString);

        const month = new Intl.DateTimeFormat('id-ID', { month: 'short' }).format(date);
        
        const day = new Intl.DateTimeFormat('id-ID', { day: 'numeric' }).format(date);
        
        const time = new Intl.DateTimeFormat('id-ID', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZone: 'Asia/Jakarta'
        }).format(date).replace(':', '.');

        return `${month} ${day}, ${time}`;
    }

    const renameSession = () => {
        let data = JSON.stringify({
            "session_id": idSession,
            "new_name": nameSession
        });

        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/video/session/rename`,
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
        };

        apiClient.request(config)
        .then((response) => {
            historyGenerate()
        })
        .catch((error) => {
            console.log(error);
        });
    }
    const deleteSession = () => {
        let config = {
            method: 'delete',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/video/session/${idSession}`,
        };

        apiClient.request(config)
        .then((response) => {
            historyGenerate();
            setHasilGenerate(null); 
            setDuration(0); setInstruct(""); setListVideoSession(null); setIdSession(""); setFileTarget([]); setInputDuration(0);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const historyGenerate = () => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/video/session/byUserID`,
        };

        apiClient.request(config)
        .then((response) => {
            checkCredit();
            setTotalHistory(response.data.total);
            setArrHistory((response.data.data_sessions).reverse())
            setEditIndex(null)
        })
        .catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        console.log(arrHistory)
    }, [arrHistory])

    const fetchVideoAsBlobUrl = async (id, fileName) => {
        console.log(`${process.env.REACT_APP_API_URL}/video/${id}/${fileName}`)

        const response = await apiClient.get(
            `${process.env.REACT_APP_API_URL}/video/${id}/${fileName}`,
            // {
            // responseType: 'blob',
            // }
        );
        console.log("Response = ", response)

        // const videoBlob = new Blob([response.data], { type: 'video/mp4' });
        // return URL.createObjectURL(videoBlob);
        return response.data.video
    };

    const calculateTotalDuration = (array) => {
        // Menghitung total durasi video
        const durationPromises = array.map(blobUrl => {
            return new Promise((resolve) => {
                const video = document.createElement('video');
                video.preload = 'metadata';
                video.src = blobUrl;
                video.onloadedmetadata = () => {
                    resolve(Math.floor(video.duration));
                };
                video.onerror = () => {
                    resolve(0);
                };
            });
        });
        
        Promise.all(durationPromises).then((durations) => {
            setListVideoDuration(durations)
            const totalDuration = durations.reduce((sum, duration) => sum + duration, 0);
            const totalDurationMinutes = Math.floor(totalDuration / 60);
            const totalDurationSeconds = Math.floor(totalDuration % 60);
            
            setInputDuration(totalDuration);
            console.log(`Total durasi video: ${totalDuration.toFixed(2)} detik (${totalDurationMinutes}:${totalDurationSeconds.toString().padStart(2, '0')})`);
            console.log(`Jumlah video: ${array.length}`);
            console.log(`Rata-rata durasi per video: ${(totalDuration / array.length).toFixed(2)} detik`);
            console.log(`inputDuration di-set ke: ${totalDuration}`);
        });
    }

    const viewListVideo = async (id, array) => {
        try {
            const promises = array.map(fileName => fetchVideoAsBlobUrl(id, fileName));
            const ar = await Promise.all(promises);
            if(id != "") {
                console.log("DUR = ",  ar)
                setListVideoSession(ar)
                calculateTotalDuration(ar)
            } else {
                console.log("DXR = ",  ar)
                setListVideoSession(null)
                setInputDuration(0) // Reset inputDuration ketika tidak ada session
            }
        } catch (error) {
            console.error('Salah satu video gagal:', error);
        }
        
    };

    useEffect(() => {
        console.log("DOR = ",  listVideoSession)
    }, [listVideoSession])

    // Reset inputDuration ketika idSession kosong
    useEffect(() => {
        if (idSession === "") {
            setInputDuration(0);
        }
    }, [idSession])

    // Socket management - track sockets by session ID
    const socketsRef = useRef(new Map());
    
    // Helper functions for localStorage persistence
    const STORAGE_KEY = 'video_progress_map';
    
    const loadProgressFromStorage = useCallback(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored) {
                return JSON.parse(stored);
            }
        } catch (error) {
            console.error('Error loading progress from storage:', error);
        }
        return {};
    }, []);

    const saveProgressToStorage = useCallback((progressMap) => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(progressMap));
        } catch (error) {
            console.error('Error saving progress to storage:', error);
        }
    }, []);

    const removeProgressFromStorage = useCallback((sessionId) => {
        try {
            const stored = loadProgressFromStorage();
            if (stored[sessionId]) {
                delete stored[sessionId];
                saveProgressToStorage(stored);
            }
        } catch (error) {
            console.error('Error removing progress from storage:', error);
        }
    }, [loadProgressFromStorage, saveProgressToStorage]);

    // Percentage state per session - initialize from localStorage
    const [persentaMap, setPersentaMap] = useState(() => {
        return loadProgressFromStorage();
    });

    // Function to get or create socket for a session
    const getOrCreateSocket = useCallback((sessionId) => {
        if (!sessionId) return null;

        // If socket already exists for this session, return it
        if (socketsRef.current.has(sessionId)) {
            const existingSocket = socketsRef.current.get(sessionId);
            // Check if socket is connected
            if (existingSocket.connected) {
                return existingSocket;
            }
            // If disconnected, remove it and create a new one
            existingSocket.disconnect();
            socketsRef.current.delete(sessionId);
        }

        // Create new socket for this session
        const urlSocketIO = `${process.env.REACT_APP_WSS_URL}?session_id=${sessionId}`;
        const socket = io(urlSocketIO, {
            transports: ["websocket"]
        });

        // Set up event listeners
        socket.on('video_generate_status', (data) => {
            console.log(`🎥 Update status video [${sessionId}]:`, data);
            
            setPersentaMap(prev => {
                const updated = {
                    ...prev,
                    [sessionId]: data.percentage
                };
                // Save to localStorage
                saveProgressToStorage(updated);
                return updated;
            });

            if(data.percentage == 100) {
                setTimeout(() => {
                    historyGenerate();
                    
                    setPersentaMap(prev => {
                        const updated = { ...prev };
                        delete updated[sessionId];
                        // Remove from localStorage
                        removeProgressFromStorage(sessionId);
                        return updated;
                    });
                    // Disconnect and remove socket when done
                    if (socketsRef.current.has(sessionId)) {
                        const socketToDisconnect = socketsRef.current.get(sessionId);
                        socketToDisconnect.disconnect();
                        socketsRef.current.delete(sessionId);
                    }
                }, 1000);
            }
        });

        socket.on('video_generate_data', (data) => {
            console.log(`┐ Update status Data [${sessionId}]:`, data);
            if(!data.status) {
                // Only update if this is the active session
                if(sessionId === idSession && idSession != "") {
                    setHasilGenerate(data);

                    if(data.sources && Array.isArray(data.sources)) {
                        const processedVideos = data.sources.map(item => {
                            const underscoreIndex = item.indexOf('_');
                            return underscoreIndex !== -1 ? item.substring(underscoreIndex + 1) : item;
                        });
                        viewListVideo(sessionId, processedVideos)
                        // getListVideoSession(sessionId)
                        setListVideoNames(processedVideos)
                    }
                }
            }
        });

        socket.on('connect', () => {
            console.log(`✅ Socket connected for session: ${sessionId}`);
        });

        socket.on('disconnect', () => {
            console.log(`❌ Socket disconnected for session: ${sessionId}`);
        });

        socket.on('error', (error) => {
            console.error(`❌ Socket error for session ${sessionId}:`, error);
        });

        // Store socket in map
        socketsRef.current.set(sessionId, socket);
        return socket;
    }, [idSession, historyGenerate, saveProgressToStorage, removeProgressFromStorage]);

    // Function to disconnect a specific socket
    const disconnectSocket = useCallback((sessionId) => {
        if (socketsRef.current.has(sessionId)) {
            const socket = socketsRef.current.get(sessionId);
            socket.disconnect();
            socketsRef.current.delete(sessionId);
            
            // Clear percentage for this session
            setPersentaMap(prev => {
                const updated = { ...prev };
                delete updated[sessionId];
                // Remove from localStorage
                removeProgressFromStorage(sessionId);
                return updated;
            });
        }
    }, [removeProgressFromStorage]);

    // Function to disconnect all sockets
    const disconnectAllSockets = useCallback(() => {
        socketsRef.current.forEach((socket, sessionId) => {
            console.log(`Disconnecting socket for session: ${sessionId}`);
            socket.disconnect();
        });
        socketsRef.current.clear();
        setPersentaMap({});
        // Note: We don't clear localStorage here intentionally - keep progress for reload
    }, []);

    // Get percentage from status string
    const getPercentageFromStatus = useCallback((statusString) => {
        if (!statusString) return 0;
        
        switch (statusString) {
            case "Ready to generate":
                return 0;
            case "Directory scanned. Starting analysis...":
                return 20;
            case "Queuing video(s)...":
                return 25;
            case "Uploading video(s)...":
                return 30;
            case "Analyzing video(s)...":
                return 40;
            case "Drafting edit plans...":
                return 60;
            case "Editing clips...":
                return 80;
            case "Done: Generate":
                return 100;
            default:
                return 0;
        }
    }, []);

    // Get percentage for a specific session
    const getPersenta = useCallback((sessionId) => {
        return persentaMap[sessionId] || null;
    }, [persentaMap]);

    // Get display percentage - prioritize socket progress, fallback to status-based
    const getDisplayPercentage = useCallback((sessionId, statusString) => {
        // First check if we have real-time progress from socket
        const socketProgress = getPersenta(sessionId);
        if (socketProgress !== null && socketProgress !== undefined) {
            return socketProgress;
        }
        
        // Fallback to status-based percentage
        if (statusString) {
            try {
                const statusObj = JSON.parse(statusString);
                if (statusObj && statusObj.status) {
                    return getPercentageFromStatus(statusObj.status);
                }
            } catch (error) {
                console.error('Error parsing status:', error);
            }
        }
        
        return 0;
    }, [getPersenta, getPercentageFromStatus]);

    // Sync progress from status to localStorage for active sessions (fallback if socket not connected)
    useEffect(() => {
        if (arrHistory.length === 0) return;

        arrHistory.forEach(item => {
            if (!item.status || !item.id) return;
            
            try {
                const statusObj = JSON.parse(item.status);
                if (statusObj && statusObj.status && statusObj.status !== "Done: Generate" ) {
                    const statusBasedProgress = getPercentageFromStatus(statusObj.status);
                    
                    // Only update if we don't have socket progress or status-based is higher
                    setPersentaMap(prev => {
                        const currentProgress = prev[item.id];
                        
                        // If no socket progress exists, use status-based progress
                        if (currentProgress === null || currentProgress === undefined) {
                            const updated = {
                                ...prev,
                                [item.id]: statusBasedProgress
                            };
                            saveProgressToStorage(updated);
                            return updated;
                        }
                        
                        // If socket progress exists, keep it (it's more accurate)
                        return prev;
                    });
                }
            } catch (error) {
                // Ignore parsing errors
            }
        });
    }, [arrHistory, getPercentageFromStatus, saveProgressToStorage]);

    // Cleanup localStorage for completed sessions
    useEffect(() => {
        if (arrHistory.length === 0) return;

        const completedSessionIds = arrHistory
            .filter(item => {
                if (!item.status) return false;
                try {
                    const status = JSON.parse(item.status);
                    return status && status.status === "Done: Generate";
                } catch {
                    return false;
                }
            })
            .map(item => item.id);

        // Cleanup progress from localStorage for completed sessions
        completedSessionIds.forEach(sessionId => {
            removeProgressFromStorage(sessionId);
            // Also cleanup from state if exists
            setPersentaMap(prev => {
                if (prev[sessionId]) {
                    const updated = { ...prev };
                    delete updated[sessionId];
                    return updated;
                }
                return prev;
            });
        });
    }, [arrHistory, removeProgressFromStorage]);

    // Manage sockets for all active sessions
    useEffect(() => {
        // Get all sessions that need socket monitoring
        const activeSessions = arrHistory
            .filter(item => {
                if (!item.status) return false;
                try {
                    const status = JSON.parse(item.status);
                    return status && status.status !== "Done: Generate";
                } catch {
                    return false;
                }
            })
            .map(item => item.id);

        // Create/update sockets for active sessions
        activeSessions.forEach(sessionId => {
            getOrCreateSocket(sessionId);
        });

        // Cleanup: disconnect sockets for sessions that are no longer active
        const currentSessionIds = new Set(activeSessions);
        socketsRef.current.forEach((socket, sessionId) => {
            if (!currentSessionIds.has(sessionId)) {
                disconnectSocket(sessionId);
            }
        });
    }, [arrHistory, getOrCreateSocket, disconnectSocket]);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            disconnectAllSockets();
        };
    }, [disconnectAllSockets]);

    const getListVideoSession = (id) => {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}/video/input?video_session=${id}`,
            };
            
            apiClient.request(config)
            .then((response) => {
                console.log(response.data.data);
                // Simpan array nama video ke state
                if(response.data.data && Array.isArray(response.data.data)) {
                    setListVideoNames(response.data.data);
                } else {
                    setListVideoNames([]);
                }
            })
            .catch((error) => {
                console.log(error);
                setListVideoNames([]);
            });
    }

    // Reset listVideoNames ketika idSession kosong
    // useEffect(() => {
    //     if (!idSession || idSession === "") {
    //         setListVideoNames([]);
    //     }
    // }, [idSession]);   




    return (
   <div className="flex min-h-screen">
      {/* Sidebar */}

    {isMobile && buka && (
        <div
          className="fixed inset-0 bg-black/60 z-40 md:hidden "
          onClick={() => setBuka(false)}
        />
      )}

        <aside
            className={`text-white transition-all duration-200 ease-in-out min-h-screen  border-r border-[#252525]
                ${isMobile
                ? `${buka ? 'translate-x-0 z-50 bg-[#1616168f] backdrop-blur-[4px]' : '-translate-x-full'} fixed inset-y-0 left-0 w-64`
                : `${buka ? 'w-80' : 'w-0'} hidden md:flex`} flex flex-col`
            }
        >
            <div className="flex flex-col gap-4 px-4 py-8">

            {buka && (
                <>
                <div className="w-10 h-10 rounded-xl bg-primary/20 flex items-center justify-center glow-primary">
                    <Video className="w-5 h-5 text-primary" />
                </div>
                    
                <nav className="mt-6 space-y-4">
                    <button 
                        className="group relative inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-[#1d1d1d] font-medium hover:bg-[#171717] hover:shadow-lg hover:shadow-primary/20 hover:scale-[1.02] active:scale-[0.98] h-10 px-4 py-2 w-full overflow-hidden touch-manipulation select-none border border-transparent hover:border-primary/30"
                        style={{color: "#a3a3a3"}} 
                        onClick={() => {
                            // Reset semua state ke default
                            setHasilGenerate(null);
                            setDuration(0);
                            setInstruct("");
                            setListVideoSession(null);
                            setIdSession("");
                            setFileTarget([]);
                            setRightPanelValue(null);
                            setHasilCheck(null);
                            setTextLoading("");
                            setEditIndex(null);
                            setEditOrDel("");
                            setNameSession("");
                            setListVideoNames([]);
                            setInputDuration(0);
                        }}
                    >
                        {/* Animated background gradient sweep */}
                        <span className="absolute inset-0 bg-gradient-to-r from-primary/0 via-primary/10 to-primary/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 -translate-x-full group-hover:translate-x-full" style={{transition: 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s ease-in-out'}} />
                        
                        {/* Ripple effect overlay for click feedback */}
                        <span className="absolute inset-0 rounded-lg bg-white/0 active:bg-white/10 transition-colors duration-150 pointer-events-none" />
                        
                        {/* Subtle glow effect */}
                        <span className="absolute inset-0 rounded-lg bg-primary/0 group-hover:bg-primary/5 blur-md transition-all duration-500 pointer-events-none" />
                        
                        {/* Content with z-index to stay on top */}
                        <div className="relative z-10 flex items-center gap-2">
                            <Plus className="w-4 h-4 transition-all duration-300 group-hover:rotate-90 group-hover:scale-110 group-hover:text-primary" />
                            <span className="ml-2 transition-colors duration-300 group-hover:text-primary/90 font-medium">New Generate</span>
                        </div>
                        
                        {/* Shine/shimmer effect on hover */}
                        <span className="absolute inset-0 -skew-x-12 bg-gradient-to-r from-transparent via-white/15 to-transparent opacity-0 group-hover:opacity-100 group-hover:animate-shimmer pointer-events-none" />
                    </button>

                    {totalHistory != null && totalHistory != 0 && (
                        <>
                        <div className="flex items-center gap-2 text-muted-foreground pt-4">
                            <History className="w-4 h-4" />
                            <span>History</span>
                        </div>
                        
                        {arrHistory.length !== 0 && (
                        <>
                            {arrHistory.map((item, index) => (
                            <div
                                key={index}
                                className={`
                                    relative
                                    flex 
                                    justify-between 
                                    items-center 
                                    gap-2 
                                    group 
                                    py-2 
                                    px-3 
                                    rounded-lg 
                                    cursor-pointer
                                    transition-all 
                                    duration-300
                                    overflow-hidden
                                    touch-manipulation
                                    select-none
                                    ${
                                        item.id == idSession
                                            ? "bg-gradient-to-r from-primary/20 via-primary/15 to-primary/20 border border-primary/40 shadow-lg shadow-primary/10 scale-[1.02]"
                                            : "bg-black/10 border border-white/10 hover:bg-white/10 hover:border-white/20 hover:scale-[1.01] active:scale-[0.99]"
                                    }
                                `}
                                onClick={() => {
                                    setListVideoSession(null)
                                    setTimeout(() => {
                                        if(item.id != idSession) {
                                            setFileTarget([])
                                            setHasilGenerate(JSON.parse(item.result_path)); 
                                            setDuration(JSON.parse(item.settings).duration); 
                                            setInstruct(JSON.parse(item.settings).instructions); 
                                            viewListVideo(item.id, item.source_path); 
                                            setIdSession(item.id); 
                                            console.log(JSON.parse(item.result_path))
                                            if(isMobile) {
                                                setTimeout(() => {
                                                    setBuka(false)
                                                }, 1000)
                                            }
                                            getListVideoSession(item.id)
                                        }
                                    }, 500)
                                }}
                            >
                                {/* Selected state glow effect */}
                                {item.id == idSession && (
                                    <>
                                        <span className="absolute inset-0 bg-gradient-to-r from-primary/10 via-primary/5 to-primary/10 blur-sm pointer-events-none" />
                                        <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 group-hover:animate-shimmer pointer-events-none" />
                                    </>
                                )}
                                
                                {/* Hover ripple effect */}
                                <span className="absolute inset-0 rounded-lg bg-white/0 active:bg-white/10 transition-colors duration-150 pointer-events-none" />
                                
                                {/* Left border indicator for selected state */}
                                {item.id == idSession && (
                                    <span className="absolute left-0 top-0 bottom-0 w-1 bg-primary rounded-l-lg shadow-[0_0_8px_rgba(29,175,161,0.6)]" />
                                )}
                                <div className="flex-1 relative z-10">
                                {editIndex === index && editOrDele != "delete"? (
                                    <input
                                    type="text"
                                    defaultValue={item.session_name || `Video ${index + 1}`}
                                    autoFocus
                                    className="text-xs border border-white/10 rounded px-2 py-1 w-full bg-background focus:border-white/30 focus-visible:outline-2"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                        setEditIndex(null);
                                        renameSession()
                                        }
                                    }}
                                    onChange={(e) => {setNameSession(e.target.value)}}
                                    />
                                ) : (
                                    <p className={`text-xs transition-colors duration-300 ${
                                        item.id == idSession ? "text-white font-medium" : "text-gray-300"
                                    }`}>
                                    {item.session_name == null ? `Video ${index + 1}` : item.session_name}
                                    </p>
                                )}
                                
                                {item.created_at && (
                                    <span className={`text-[10px] transition-colors duration-300 ${
                                        item.id == idSession ? "text-gray-300" : "text-muted-foreground"
                                    }`}>
                                    {formatBulanTanggalWaktu(item.created_at)}
                                    </span>
                                )}

                                {item.status && JSON.parse(item.status) ? <>
                                    {JSON.parse(item.status).status === "Done: Generate" ? (
                                        <>
                                        <CheckCircle className="w-5 h-5 text-green-500 mt-1 transition-transform duration-300 group-hover:scale-110" />
                                        </>
                                    ) : (
                                        <>
                                        <div className="flex gap-1 items-center mt-1">
                                            <Loader2 className="w-5 h-5 text-yellow-500 animate-spin" />
                                            <p className="text-xs">{getDisplayPercentage(item.id, item.status)}%</p>
                                        </div>
                                        </>
                                    )}
                                </> : <>
                                    <Clock className="w-5 h-5 text-red-500 mt-1 transition-transform duration-300 group-hover:scale-110" />
                                </>}
                                {/* <CheckCircle className="w-5 h-5 text-green-500 mt-1" /> */}
                                
                                {/* <Clock className="w-5 h-5 text-red-500 mt-1" /> */}
                                </div>

                                <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 relative z-10">
                                {editIndex === index ? (
                                    <>
                                    {editOrDele === "edit" ? (
                                        <>
                                            <button
                                                className="p-1 rounded hover:bg-green-500/10 transition-colors"
                                                aria-label="Simpan"
                                                onClick={() => {if(nameSession != item.session_name) {renameSession()} else {setEditIndex(null)}}} 
                                            >
                                                <Check className="w-5 h-5 text-primary hover:text-primary/80" />
                                            </button>
                                            <button
                                                className="p-1 rounded hover:bg-red-500/10 transition-colors"
                                                aria-label="Batal"
                                                onClick={() => setEditIndex(null)}
                                            >
                                                <X className="w-5 h-5 text-red-500 hover:text-red-600" />
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button
                                                className="p-1 rounded hover:bg-red-500/10 transition-colors"
                                                aria-label="Batal"
                                                onClick={() => setEditIndex(null)}
                                            >
                                                <X className="w-5 h-5 text-red-500 hover:text-red-600" />
                                            </button>
                                            <button
                                                className="p-1 rounded hover:bg-green-500/10 transition-colors"
                                                aria-label="Simpan"
                                                onClick={() => {deleteSession()}} 
                                            >
                                                <Check className="w-5 h-5 text-primary hover:text-primary/80" />
                                            </button>
                                            
                                        </>
                                    )}

                                    </>
                                ) : (
                                    <>
                                    <button
                                        className="p-1 rounded hover:bg-green-500/10 transition-colors"
                                        aria-label="Edit"
                                        onClick={(e) => {
                                        // e.stopPropagation();
                                        setEditIndex(index);
                                        setEditOrDel('edit');
                                        setNameSession(item.session_name == null ? `Video ${index + 1}` : item.session_name); 
                                        setIdSession(item.id)
                                        }}
                                    >
                                        <Pencil className="w-5 h-5 text-primary hover:text-primary/80" />
                                    </button>
                                    <button
                                        className="p-1 rounded hover:bg-red-500/10 transition-colors"
                                        aria-label="Hapus"
                                        onClick={(e) => {
                                        // e.stopPropagation();
                                        setEditIndex(index);
                                        setEditOrDel('delete')
                                        setIdSession(item.id)
                                        }}
                                    >
                                        <Trash className="w-5 h-5 text-red-500 hover:text-red-600" />
                                    </button>
                                    </>
                                )}
                                </div>
                            </div>
                            ))}
                        </>
                        )}
                        
                        </>

                        
                    )}
                    
                </nav>
                </>
            )}
            </div>
        </aside>
        <div className=" min-h-screen p-4 lg:p-6 flex-col flex gap-6 w-full">
            <header className="flex items-center justify-between">
                <div className="flex items-center gap-3 cursor-pointer" onClick={() => {setBuka(!buka)}}>
                    {buka ? <PanelRightOpen className="w-12 h-12 text-primary p-2 hover:bg-[#212121] transition-all duration-300 rounded-lg"/> : <PanelRightClose className="w-12 h-12 text-primary p-2 hover:bg-[#212121] transition-all duration-300 rounded-lg"/>}
                    {/* <div className="w-10 h-10 rounded-xl bg-primary/20 flex items-center justify-center glow-primary">
                    <Video className="w-5 h-5 text-primary" />
                    </div> */}
                                {(!isMobile || buka) && (
              <h1 className="text-xl font-bold text-foreground hidden sm:block">
                Video Editor Pro Example
              </h1>
            )}
                </div>
                
                <div className="flex gap-4">
                    {muncul && (
                    <div className="bg-[#504F04] text-white px-3 py-1 rounded-lg flex items-center gap-2 font-medium" style={{border: '1px solid #9F8F00'}}>
                        <Gem size={16} strokeWidth={2} />
                        <span>{quota}</span>
                    </div>
                    )}
                    
                    <button 
                        className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-muted hover:text-foreground h-9 rounded-md px-3 relative group"
                        onClick={() => setIsChangePasswordOpen(true)}
                        title="Change Password"
                    >
                        <KeyRound className="w-4 h-4 transition-transform duration-300 group-hover:rotate-12 group-hover:scale-110" />
                        <span className="hidden sm:inline">Change Password</span>
                    </button>
                    
                    <button className=" inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-muted hover:text-foreground h-9 rounded-md px-3" variant="ghost" size="sm" onClick={handleLogout}>
                        <LogOut className="w-4 h-4 mr-2" />
                        <p className="">Logout</p>
                    </button>
                </div>

            </header>
            <div className="flex-col md:flex-row bg-black text-white flex gap-6 select-none font-[geist]">
                <LeftPanel terima={rightPanelValue} hapus={() => setRightPanelValue(null)} ambilHasilGen={setHasilGenerate} generateVideo={() => {generateVideo()}} bukaModal={() => setIsModalOpen(true)} tutupModal={() => setIsModalOpen(false)} ambilHasilCheck={setHasilCheck} getFile={fileTarget} setFile={setFileTarget} getDurasi={duration} setDurasi={setDuration} getInstruksi={instruct} setInstruksi={setInstruct} setTotalHistory={setTotalHistory} setArrHistory={setArrHistory} listVideoSession={listVideoSession} setListVideoSession={setListVideoSession} setIdSession={setIdSession} idSession={idSession} listVideoNames={listVideoNames} listVideoDuration={listVideoDuration} refreshVideoList={getListVideoSession} setListVideoNames={setListVideoNames} outputResult={outputResult} setOutputResult={setOutputResult} inputDuration={inputDuration}/>
                <RightPanel ambil={setRightPanelValue} terimaHasilGen={hasilGenerate} idSession={idSession} outputResult={outputResult} setOutputResult={setOutputResult} checkCredit={checkCredit}/>
            </div>


            {/* <button onClick={openModal}>Buka Modal</button> */}
            <Modal isOpen={isModalOpen} onClose={closeModal}>
                <div className="flex justify-center">
                    <img src={cat} className="w-[120px]"/>
                </div>

                {!hasilCheck ? (
                    <>
                    <p className="modal-text">Generating your magic<AnimatedDots /> </p>
                    {/* <p className="modal-text" style={textLoading === "" ? {opacity: '0'} : {opacity: "1"}}> 🎥 Status video : {textLoading} </p> */}
                    <p className="modal-text">Don’t worry—my tiny ghost friend is keeping me company!</p>
                    <p className="modal-text">He’s fluffing clouds, stirring stardust, and making sure everything turns out perfectly for you. 💫</p>
                    </>
                ) : (
                    <>
                    <p className="modal-text">You have <b>{quota}</b> credit</p>
                    <p className="modal-text">The estimated credit cost for generating this video is <b>{hasilCheck}</b> credit(s)</p>
                    <p className="modal-text">(You’ll be charged only if you confirm.)</p>

                    <div className="flex w-[100%] justify-evenly">
                        <button className="w-[160px] bg-[#2b2b2b] hover:bg-[#171919] justify-center text-white px-4 py-2 rounded-lg flex items-center gap-2 font-medium transition-colors duration-200" style={{border: "1px solid #656C7B"}} onClick={() => {closeModal(); setHasilCheck(null)}}>Close</button>
                        <button className="w-[160px] justify-center bg-[#044250] hover:bg-[#03333d] text-white px-4 py-2 rounded-lg flex items-center gap-2 font-medium transition-colors duration-200" style={{border: "1px solid #00FFD1"}}
                        onClick={() => {generateVideo()}}>Generate Video</button>
                    </div>
                    </>
                )}

            </Modal>

            {/* Change Password Modal */}
            <ChangePassword 
                isOpen={isChangePasswordOpen} 
                onClose={() => setIsChangePasswordOpen(false)} 
            />
        </div>
        </div>

    )
}

const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {/* <button className="modal-close" onClick={onClose}>x</button> */}
            <div className="flex h-[100%] flex-col justify-center items-center gap-4">
                {children}
            </div>
            
        </div>
        </div>
    );
};

export default Dashboard